module.exports = __webpack_public_path__ + "static/media/ahi-pi-not-indicated.5ca8af73.svg";